import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export default {
  search,
  get,
  create,
  update,
  linkToCase,
  unlinkFromCase,
  getProvidersForCase,
  getLibraryAudit,
  mergeProviders,
  reclassifyProvider,
  fixMalformedName,
  assignAffiliation,
  undoLibraryAction,
}

function search(searchInput) {
  const body = typeof searchInput === 'string' ? { searchText: searchInput, page: 1, take: 20 } : searchInput
  return wrapFetch(
    fetch('/api/provider/search', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }),
  ).onSuccess(json => json)
}

function get(id) {
  return wrapFetch(
    fetch(`/api/provider/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }),
  ).onSuccess(json => json)
}

function create(model) {
  return wrapFetch(
    fetch('/api/provider', {
      method: 'POST',
      body: JSON.stringify(model),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function update(id, model) {
  return wrapFetch(
    fetch(`/api/provider/${id}`, {
      method: 'PUT',
      body: JSON.stringify(model),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function linkToCase(caseId, providerId) {
  return wrapFetch(
    fetch(`/api/provider/${caseId}/link/${providerId}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }),
  ).onSuccess(json => json)
}

function unlinkFromCase(caseId, providerId) {
  return wrapFetch(
    fetch(`/api/provider/${caseId}/link/${providerId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }),
  ).onSuccess(json => json)
}

function getProvidersForCase(caseId) {
  return wrapFetch(
    fetch(`/api/provider/case/${caseId}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }),
  ).onSuccess(json => json)
}

function getLibraryAudit(providerType) {
  const url = providerType
    ? `/api/provider/library-audit?providerType=${encodeURIComponent(providerType)}`
    : '/api/provider/library-audit'
  return wrapFetch(
    fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function mergeProviders(request) {
  return wrapFetch(
    fetch('/api/provider/merge', {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function reclassifyProvider(request) {
  return wrapFetch(
    fetch('/api/provider/reclassify', {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function fixMalformedName(request) {
  return wrapFetch(
    fetch('/api/provider/fix-name', {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function assignAffiliation(request) {
  return wrapFetch(
    fetch('/api/provider/assign-affiliation', {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}

function undoLibraryAction(request) {
  return wrapFetch(
    fetch('/api/provider/undo-action', {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  ).onSuccess(json => json)
}
